import React from "react";
import { FiMail } from "react-icons/fi";
import { Formik } from "formik";
import { MdClose } from "react-icons/md";

import AccordionItens from "components/Religue/AccordionItens";
import ContainedButton from "components/layout/form/containedButton";
import Loading from "components/layout/loading";
import Navbar from "components/MI/Navbar";
import OutlinedButton from "components/layout/form/outlinedButton";
import TextField from "components/layout/form/textField";
import TourBalloon from "components/NewTour/TourBallon";
import UserMenu from "components/layout/userMenuNew";
import ValvulaImg from "assets/images/valvula.jpeg";

import {
  Body,
  Button,
  Container,
  ContentButtons,
  ContentEditEmail,
  ContentField,
  Details,
  Field,
  FormContainer,
  FormEditIcon,
  Header,
  HeaderInfos,
  HeaderSubtitle,
  HeaderTitle,
  ModalBody,
  ModalContainer,
  ModalContent,
  ModalContentInfosReligue,
  ModalFooter,
  ModalHeader,
  ModalStyle,
  StatusUnit,
  StatusUnitContent,
  Step,
} from "../styles";
import { useReliguePage } from "../hooks/useReliguePage";
import {
  validatorSchemaEmail,
  validatorSchemaToken,
} from "../utils/validationSchemas";
import type { UseReliguePageReturn } from "../types/religueHookReturn";

const ReliguePage = (): JSX.Element => {
  const {
    loading,
    loadingSolicitCase,
    buttonLoading,
    openModal,
    setOpenModal,
    openModalInfo,
    setOpenModalInfo,
    openModalTurnOff,
    setOpenModalTurnOff,
    modalWithLink,
    setModalWithLink,
    modalInfos,
    activeKey,
    setActiveKey,
    email,
    setEmail,
    buttonModalTurnOff,
    setButtonModalTurnOff,
    loadingButtonValidateToken,
    setLoadingButtonValidateToken,
    suspensions,
    selectedUnit,
    showTour,
    tourStep,
    tourType,
    renderBannerStatus,
    handleSolicit,
    handleSolicitBlocked,
    handleSolicitTurnOff,
    sendToken,
    validationToken,
    reconnections,
    openUlly,
  } = useReliguePage() as unknown as UseReliguePageReturn;
  return (
    <Navbar selected="religue">
      <UserMenu breadcrump={null} intro />
      <Container
        showTour={tourStep === 1 && tourType === "religue" && showTour}
      >
        <Header>
          <HeaderInfos>
            <HeaderTitle>Ligar e desligar gás</HeaderTitle>
            <HeaderSubtitle>
              Com alguns cliques você liga e desliga o gás da sua unidade.
              Entenda os detalhes:
            </HeaderSubtitle>
          </HeaderInfos>
        </Header>
        <Body>
          <Details>
            <StatusUnitContent>
              <StatusUnit
                status={selectedUnit?.status === "ON" ? "on" : "off"}
              />
              Sua unidade está com o gás{" "}
              {selectedUnit?.status === "ON" ? "ligado" : "desligado"}
            </StatusUnitContent>
            {renderBannerStatus}
          </Details>
          <AccordionItens
            activeKey={activeKey}
            setActiveKey={(key) => setActiveKey(key === activeKey ? null : key)}
            items={[
              {
                title: "Solicitar desligue de fornecimento por saída do imóvel",
                description: (
                  <>
                    <span>Quando solicitar o serviço?</span>
                    <p>
                      Ao sair do seu imóvel é preciso que solicite o{" "}
                      <b>desligamento do gás</b> ou que o novo morador da
                      unidade faça o primeiro acesso ao Portal Minha UItragaz. O
                      desligamento da sua unidade encerra o serviço prestado em
                      seu nome.
                    </p>

                    <span>Como reverter o serviço?</span>
                    <p>
                      Para retomar o consumo o novo morador deverá realizar o
                      primeiro acesso no portal e a ligação da unidade será
                      executada em até 5 dias úteis.
                    </p>

                    <span>O serviço é cobrado?</span>
                    <p>
                      Não há custo para{" "}
                      <a href="#" onClick={() => setActiveKey(1)}>
                        &quot;Desligue por saída do imóvel&quot;
                      </a>{" "}
                      ou{" "}
                      <a href="#" onClick={() => setActiveKey(2)}>
                        &quot;Ligação de fornecimento da unidade de um novo
                        morador&quot;
                      </a>
                      .
                    </p>

                    <ContentButtons>
                      <ContainedButton
                        disabled={
                          suspensions?.length > 0 ||
                          loadingSolicitCase ||
                          selectedUnit?.status !== "ON"
                        }
                        loading={buttonLoading || loadingSolicitCase}
                        onClick={() => setOpenModalTurnOff(true)}
                      >
                        Solicitar
                      </ContainedButton>
                    </ContentButtons>
                  </>
                ),
              },
              {
                title: "Ligação de fornecimento da unidade de um novo morador",
                description: (
                  <>
                    <span>Quando solicitar o serviço?</span>
                    <p>
                      Após realizar o primeiro acesso ao portal, a ligação de
                      fornecimento da unidade será solicitado automaticamente.
                      Para realizar o ligue de uma nova unidade que ainda não
                      está em seu nome,{" "}
                      <a href="/adicionar-unidade">
                        &quot;Adicione nova unidade&quot;
                      </a>{" "}
                      , e será solicitado automaticamente.
                    </p>
                    <p>
                      Para retomar uma unidade que já esteve em seu nome, por
                      favor, entre em contato com o atendimento:
                    </p>
                    <p>
                      <span>Regiões Metropolitanas: 4003-1616</span>
                      <span>Demais regiões: 0800-886-1616</span>
                    </p>

                    <span>Como reverter o serviço?</span>
                    <a href="#" onClick={() => setActiveKey(1)}>
                      Solicitar desligue de fornecimento por saída do imóvel
                    </a>
                    <a href="#" onClick={() => setActiveKey(5)}>
                      Solicitar bloqueio de fornecimento temporário
                    </a>

                    <span>O serviço é cobrado?</span>
                    <p>
                      Não há custo para &quot;Ligação da unidade de um novo
                      morador&quot;
                    </p>
                  </>
                ),
              },
              {
                title: "Bloqueio de fornecimento por inadimplência",
                description: (
                  <>
                    <span>Quando solicitar o serviço?</span>
                    <p>
                      É realizado pela Ultragaz quando um boleto está vencido a
                      mais de 20 dias corridos contando a partir da data de
                      vencimento.
                    </p>

                    <span>Como reverter o serviço?</span>
                    <p>
                      Após a compensação bancária do pagamento do boleto
                      (aproximadamente 3 dias úteis) a ordem de religue é
                      realizada automaticamente em até 2 dias úteis.
                    </p>
                    <p>
                      Se o pagamento já foi realizado você pode{" "}
                      <a href="#" onClick={() => setActiveKey(4)}>
                        Solicitar o religue de fornecimento.
                      </a>
                    </p>

                    <span>O serviço é cobrado?</span>
                    <p>
                      Não há custo para &quot;Bloqueio de fornecimento por
                      inadimplência&quot;, mas para o serviço de{" "}
                      <a href="#" onClick={() => setActiveKey(4)}>
                        Religue de fornecimento
                      </a>{" "}
                      será cobrado R$60,00 no boleto seguinte a execução do
                      serviço.
                    </p>
                  </>
                ),
              },
              {
                title: "Solicitar o religue de fornecimento",
                description: (
                  <>
                    <span>Quando solicitar o serviço?</span>
                    <p>
                      Quando desejar ligar a unidade que teve &quot;Bloqueio de
                      fornecimento por inadimplência&quot; ou solicitado o
                      &quot;Bloqueio de fornecimento temporário&quot;.
                    </p>
                    <p>
                      Após reconhecimento do pagamento, o prazo para religação
                      do seu gás é de até <b>2 dias úteis</b>.
                    </p>
                    <span>Como reverter o serviço?</span>
                    <a href="#" onClick={() => setActiveKey(5)}>
                      Bloqueio de fornecimento temporário
                    </a>
                    <a href="#" onClick={() => setActiveKey(1)}>
                      Solicitar desligue de fornecimento por saída do imóvel
                    </a>

                    <span>O serviço é cobrado?</span>
                    <p>Será cobrado o valor de R$60,00 no próximo boleto.</p>

                    <span>Observações adicionais:</span>
                    <ul>
                      <li>
                        Verifique se há algum boleto pendente de pagamento. Caso
                        seja identificado, gere aqui mesmo, pelo Portal Minha
                        Ultragaz, a 2ª via do seu boleto e realize o pagamento
                        imediatamente;
                      </li>
                      <li>
                        É importante que, no dia da visita, o responsável pela
                        unidade e/ou condomínio estejam no local para liberar o
                        acesso da nossa equipe técnica;
                      </li>
                      <li>
                        Para que o religue seja realizado no medidor correto, é
                        obrigatório que o número da unidade esteja visível e
                        legível. Caso a equipe técnica encontre alguma
                        divergência o religue não será executado;
                      </li>
                      <li>
                        Medidores com avarias, tais como: Ilegibilidade, visor
                        embaçado ou falta de proteção, não poderão ser
                        religados. Nesses casos, será necessária a substituição
                        do equipamento por um novo. Temos fornecedores
                        homologados que poderão lhe auxiliar, pergunte para a
                        Ully.
                      </li>
                      <li>
                        Para preservar a sua segurança, a nossa equipe técnica
                        não liberará a válvula para a passagem do gás. Com a
                        finalização da prestação do serviço, assim que possível,
                        verifique o{" "}
                        <a href="#" onClick={() => setOpenModalInfo(true)}>
                          registro &quot;abre e fecha&quot;
                        </a>
                        , localizado no seu medidor, e libere a passagem do gás;
                      </li>
                    </ul>
                    <ContentButtons>
                      <ContainedButton
                        disabled={reconnections.length > 0}
                        loading={buttonLoading}
                        onClick={handleSolicit}
                      >
                        Solicitar
                      </ContainedButton>
                    </ContentButtons>
                  </>
                ),
              },
              {
                title: "Solicitar bloqueio de fornecimento temporário",
                description: (
                  <>
                    <span>Quando solicitar o serviço?</span>
                    <p>
                      Quando desejar bloquear o fornecimento de gás da sua
                      unidade por motivo de viagem ou obras, e depois retomá-lo
                      em seu nome.
                    </p>
                    <p>
                      Atenção: Para solicitar este serviço é necessária a
                      adimplência com a Ultragaz. Por favor, verifique se há{" "}
                      <a href="/boletos">boletos</a> em aberto e realize o
                      pagamento antes de solicitar o bloqueio de fornecimento
                      temporário.
                    </p>

                    <span>Como reverter o serviço?</span>
                    <p>
                      <a href="#" onClick={() => setActiveKey(4)}>
                        Solicitar o religue de fornecimento
                      </a>
                    </p>

                    <span>O serviço é cobrado?</span>
                    <p>
                      Não é cobrado o serviço de &quot;Bloqueio de fornecimento
                      temporário&quot; mas para o serviço de &quot;Religue de
                      fornecimento&quot; será cobrado R$60,00 no boleto seguinte
                      a execução do serviço.
                    </p>

                    <ContentButtons>
                      <ContainedButton
                        disabled={
                          suspensions?.length > 0 ||
                          loadingSolicitCase ||
                          selectedUnit?.status !== "ON"
                        }
                        loading={buttonLoading || loadingSolicitCase}
                        onClick={handleSolicitBlocked}
                      >
                        Solicitar
                      </ContainedButton>
                    </ContentButtons>
                  </>
                ),
              },
            ]}
          />
        </Body>
        {showTour && tourStep === 1 && tourType === "religue" && (
          <TourBalloon
            title="Ligar e desligar gás"
            content="Aqui você consulta qual o status do gás em sua unidade. Com alguns cliques você pode ligar e desligar o gás. Entenda os detalhes!"
            position={{
              left: "50%",
              top: "45px",
              arrowPosition: "unset",
              maxWidth: 320,
              boxShadow: true,
            }}
          />
        )}
      </Container>

      {/* Modal de solicitação de desligue de fornecimento */}
      <ModalStyle show={openModalTurnOff} centered animation={false}>
        <ModalContainer>
          <ModalHeader>
            <div className="wrapper">
              <span>
                Solicitar desligue de fornecimento por saída do imóvel
              </span>
            </div>
            <MdClose size={24} onClick={() => setOpenModalTurnOff(false)} />
          </ModalHeader>
          <ModalBody>
            <ModalContent>
              <div>
                <p>
                  Tem certeza que deseja{" "}
                  <b>encerrar o serviço de abastecimento da sua unidade?</b>
                </p>
                <p>Veja como funciona:</p>

                <Step>
                  <div>
                    <span>1</span>
                    <p>Solicitar desligue de fornecimento no portal</p>
                  </div>
                  <div>
                    <span>2</span>
                    <p>
                      Em até 3 dias úteis é feita a suspensão do fornecimento e
                      última leitura
                    </p>
                  </div>
                  <div>
                    <span>3</span>
                    <p>Desvinculação da unidade do CPF</p>
                  </div>
                  <div>
                    <span>4</span>
                    <p>Geração do boleto com consumo residual e pagamento</p>
                  </div>
                </Step>

                <p>
                  Para o envio do <b>boleto residual</b> precisamos que confirme
                  seu <b>e-mail:</b>
                </p>
                {buttonModalTurnOff === "request" && (
                  <ContentEditEmail>
                    <span>E-mail cadastrado: {email}</span>
                    <Button
                      onClick={() => setButtonModalTurnOff("updateEmail")}
                    >
                      <FormEditIcon />
                      <span>Editar e-mail</span>
                    </Button>
                  </ContentEditEmail>
                )}
                {buttonModalTurnOff === "updateEmail" && (
                  <Formik
                    initialValues={{
                      email: email || "",
                    }}
                    onSubmit={async ({ email: emailData }) => {
                      setLoadingButtonValidateToken(true);
                      const result = await sendToken(emailData);
                      if (result) {
                        setButtonModalTurnOff("validateToken");
                        setEmail(emailData);
                      }
                      setLoadingButtonValidateToken(false);
                    }}
                    validationSchema={validatorSchemaEmail}
                    render={({
                      handleChange,
                      handleBlur,
                      values,
                      errors,
                      touched,
                    }) => (
                      <FormContainer>
                        <ContentField>
                          <Field>
                            <TextField
                              LeadingIcon={FiMail}
                              propsLeadingIcon={{
                                size: 24,
                              }}
                              type="text"
                              name="email"
                              label="Email *"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.email}
                              errorCondition={errors.email && touched.email}
                              errorMessage={errors.email}
                              disabled={loading}
                            />
                          </Field>
                          <ContainedButton
                            type="submit"
                            disabled={
                              !values.email || loadingButtonValidateToken
                            }
                            loading={loadingButtonValidateToken}
                          >
                            Validar e-mail
                          </ContainedButton>
                        </ContentField>
                      </FormContainer>
                    )}
                  />
                )}
                {buttonModalTurnOff === "validateToken" && (
                  <Formik
                    initialValues={{
                      token: "",
                    }}
                    onSubmit={async ({ token }) => {
                      setLoadingButtonValidateToken(true);
                      const result = await validationToken(token, email);
                      if (result) {
                        setButtonModalTurnOff("request");
                      }
                      setLoadingButtonValidateToken(false);
                    }}
                    validationSchema={validatorSchemaToken}
                    render={({
                      handleChange,
                      handleBlur,
                      values,
                      errors,
                      touched,
                    }) => (
                      <FormContainer>
                        <ContentField>
                          <Field>
                            <TextField
                              LeadingIcon={FiMail}
                              propsLeadingIcon={{
                                size: 24,
                              }}
                              type="text"
                              name="token"
                              label="Token *"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.token}
                              errorCondition={errors.token && touched.token}
                              errorMessage={errors.token}
                              disabled={loading}
                            />
                          </Field>
                          <ContainedButton
                            type="submit"
                            disabled={
                              !values.token ||
                              values.token?.length !== 6 ||
                              loadingButtonValidateToken
                            }
                            loading={loadingButtonValidateToken}
                          >
                            Validar token
                          </ContainedButton>
                        </ContentField>
                      </FormContainer>
                    )}
                  />
                )}

                <p>
                  Fique tranquilo! O boleto também estará disponível aqui no
                  Portal Minha Ultragaz e nos demais canais digitais.
                </p>
              </div>
            </ModalContent>
          </ModalBody>
          <ModalFooter>
            <ContainedButton
              loading={loadingSolicitCase}
              disabled={buttonModalTurnOff !== "request" || loadingSolicitCase}
              onClick={() => handleSolicitTurnOff()}
            >
              Solicitar
            </ContainedButton>
          </ModalFooter>
        </ModalContainer>
      </ModalStyle>

      {/* Modal de infomativo das solicitações */}
      <ModalStyle show={openModal} centered animation={false}>
        <ModalContainer>
          <ModalHeader>
            <div className="wrapper">
              <span>Solicitar o Religue de fornecimento</span>
            </div>
            <MdClose size={24} onClick={() => setOpenModal(false)} />
          </ModalHeader>
          <ModalBody>
            <ModalContent>
              <div>{modalInfos?.messager}</div>
            </ModalContent>
            {modalInfos?.uac && (
              <p>
                Ainda com dúvidas?{" "}
                <a href="#" onClick={() => openUlly()}>
                  Converse com a Ully
                </a>
              </p>
            )}
          </ModalBody>
          <ModalFooter>
            {modalInfos?.cancelButton && (
              <OutlinedButton onClick={() => setOpenModal(false)}>
                Cancelar
              </OutlinedButton>
            )}
            {modalInfos?.okButtom && (
              <ContainedButton onClick={() => modalInfos.okButtom()}>
                Ok
              </ContainedButton>
            )}
            {modalInfos?.backButton && (
              <ContainedButton
                width="min(280px, 90vw) !important; margin: auto;"
                onClick={() => setOpenModal(false)}
              >
                Voltar
              </ContainedButton>
            )}
          </ModalFooter>
        </ModalContainer>
      </ModalStyle>

      {/* Modal de confirmação de solicitação o religue */}
      <ModalStyle show={modalWithLink?.open} centered animation={false}>
        <ModalContainer>
          <ModalHeader>
            <div className="wrapper">
              <span>Status da sua solicitação:</span>
            </div>
            <MdClose
              size={24}
              onClick={() =>
                setModalWithLink((prev) => ({
                  ...prev,
                  open: false,
                }))
              }
            />
          </ModalHeader>
          <ModalBody>
            <ModalContent>{modalWithLink?.description}</ModalContent>
          </ModalBody>
          <ModalFooter>
            <ContainedButton
              onClick={() =>
                setModalWithLink((prev) => ({
                  ...prev,
                  open: false,
                }))
              }
            >
              Ok
            </ContainedButton>
          </ModalFooter>
        </ModalContainer>
      </ModalStyle>

      {/* Modal de infos do religue */}
      <ModalStyle show={openModalInfo} centered animation={false}>
        <ModalContainer>
          <ModalHeader>
            <div className="wrapper">
              {/* <span>Status da sua solicitação:</span> */}
            </div>
            <MdClose size={24} onClick={() => setOpenModalInfo(false)} />
          </ModalHeader>
          <ModalBody>
            <ModalContent>
              <ModalContentInfosReligue>
                <p>
                  Ao religar/ligar o seu gás, tomamos o cuidado de manter a
                  válvula fechada para que caso alguma unidade de consumo esteja
                  aberta (boca do fogão, forno...) não ocorra vazamento.
                </p>
                <p>Para liberar, gire a válvula conforme imagem:</p>
                <img src={ValvulaImg} alt="Válvula" />
              </ModalContentInfosReligue>
            </ModalContent>
          </ModalBody>
          <ModalFooter isNotButtonFull>
            <ContainedButton
              width="260px"
              onClick={() => setOpenModalInfo(false)}
            >
              Ok
            </ContainedButton>
          </ModalFooter>
        </ModalContainer>
      </ModalStyle>
      {loading && <Loading />}
    </Navbar>
  );
};

export default ReliguePage;
